module.exports = __webpack_public_path__ + "img/landscape-indigo.d550bc13.svg";